// extracted by mini-css-extract-plugin
export default {"ClipModal":"ClipModal_ClipModal__sTp3l","CloseBtn":"ClipModal_CloseBtn__ESSM-","YoutubeVideo":"ClipModal_YoutubeVideo__c8Jvq","TextModal":"ClipModal_TextModal__EXrhL"};